import React, {Component} from 'react';
import ReactDOM from "react-dom";
import '../trace.less';
import navBarStyles from './NavBar.css';
import clemsonText from '../media/traceLogo/ClemsonText.png';
import {BrowserRouter, Route, Link, NavLink} from "react-router-dom";


function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

class NavBar extends Component {
  static defaultProps = {
    alwaysPinned: true
  };

  constructor(props) {
    super(props, NavBar.defaultProps);
    this.state = {
      pinned: this.props.alwaysPinned,
      height_px: 200,
      maxHeight_px: 210,
      minHeight_px: 0,
      percent: 100
    };
  }

  componentDidUpdate() {
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    let statesToChange = {};
    const parent = ReactDOM.findDOMNode(this).parentNode;
    const toSetHeight = clamp(parent.getBoundingClientRect().bottom, this.state.minHeight_px, this.state.maxHeight_px);
    const objectHeight = this.state.maxHeight_px - this.state.minHeight_px;
    const percent = (toSetHeight - this.state.minHeight_px) / objectHeight;


    Object.assign(statesToChange, {
      height_px: toSetHeight,
      percent: percent
    });

    if(this.props.alwaysPinned){
      this.setState({
        pinned: true,
        height_px: this.state.minHeight_px
      });
      return
    }

    let toPin = false;
    if (percent < .70) {
      toPin = true;
    }

    Object.assign(statesToChange, {
      pinned: toPin
    });


    // Process differences in state
    for (const attribute in statesToChange) {
      const stateAttributeValue = this.state[attribute];
      if (stateAttributeValue && stateAttributeValue === statesToChange[attribute])
        delete statesToChange[attribute];
    }

    if (Object.keys(statesToChange).length > 0)
      this.setState(statesToChange);
  };


  render() {
    let navBarClasses = '';
    let divStyle = {...navBarStyles};
    let traceLogoGroupClasses = '';
    if (this.state.pinned) {
      navBarClasses += 'pinned';
      traceLogoGroupClasses += 'pinned';
    }
    divStyle = {
      ...divStyle,
      height: this.state.height_px + "px",
    };


    const offset = {};
    const clemsonImageStyle = {};
    const hrStyle = {
      ...offset,
    };
    const traceLabLogoText = {
      ...offset,
    };
    const navLinks = {};

    return <div id="navBar" className={'navBar ' + navBarClasses} style={divStyle}>
      <div className="navBarContent">
        <div className={"TraceLogoGroup " + traceLogoGroupClasses}>
          <img className='clemsonLogoImg' src={clemsonText} style={clemsonImageStyle} alt=""/>
          <hr className='hr1' style={hrStyle}/>
          <h2 className="traceLabTitle" style={traceLabLogoText}>TRACE RESEARCH GROUP</h2>
          <hr className='hr2' style={hrStyle}/>
        </div>
        <div className="navLinks" style={navLinks}>
          <NavLink exact to="/" activeClassName="active">Home</NavLink>
          <NavLink to="/about" activeClassName="active">About</NavLink>
        </div>
      </div>
    </div>;
  }
}

export default NavBar;
